<template>
	<div>
		<Modal
			:show="showViewLoan"
			content_class="col-12 col-md-11 col-lg-10 col-xl-9 view-loan"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Loan Details</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showViewLoan', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="content" v-if="loan_details">
						<div class="col-12">
							<div class="card card-details">
								<div class="top">
									<div class="clearfix">
										<div
											class="f-l status tx-green"
											:class="{
												'tx-yellow':
													loan_details.status !==
													'initiated',
											}"
										>
											{{ loan_details.status }}
										</div>
									</div>
									<div class="icon-box">
										<div class="clearfix">
											<div class="f-l">
												<img
													:src="
														loan_details
															.loan_product_details
															.loan_product_img_path
													"
													alt=""
													class="logo"
												/>
											</div>
											<div class="f-l txt-box">
												<div class="product">
													{{
														loan_details
															.loan_product_details
															.loan_product_name
													}}
												</div>
												<div class="bank">
													{{
														loan_details
															.loan_product_details
															.loan_product_description
													}}
												</div>
											</div>

											<Dropdown
												class="fx-dropdown f-r"
												trigger="click"
												@on-click="clickAction($event)"
											>
												<div class="btn btn-red btn-sm">
													<i class="fa fa-wrench"></i>
													Actions
													<i
														class="fa fa-chevron-down"
													></i>
												</div>
												<DropdownMenu slot="list">
													<DropdownItem
														name="update_payment_type"
													>
														<div class="clearfix">
															<i
																class="fa fa-credit-card"
															></i>
															<div
																class="menu-text"
															>
																Update Payment
																Type
															</div>
														</div>
													</DropdownItem>
													<DropdownItem
														name="list_reviews"
													>
														<div class="clearfix">
															<i
																class="fa fa-receipt"
															></i>
															<div
																class="menu-text"
															>
																List Reviews
															</div>
														</div>
													</DropdownItem>
													<DropdownItem
														name="add_review"
													>
														<div class="clearfix">
															<i
																class="fa fa-comments"
															></i>
															<div
																class="menu-text"
															>
																Add Review
															</div>
														</div>
													</DropdownItem>
												</DropdownMenu>
											</Dropdown>
										</div>
									</div>
									<div class="detail-box">
										<div class="ref">
											Loan Ref:
											<b>{{
												loan_details.loan_application_details.application_system_ref.toUpperCase()
											}}</b>
										</div>
										<div class="payment mb-3">
											Wallet Balance:
											<span class="tx-green"
												>{{
													loan_details
														.loan_application_details
														.application_currency
												}}
												{{
													loan_details.linked_account_details.available_balance.toLocaleString(
														'us-US',
													)
												}}</span
											>
										</div>

										<div class="payment">
											Loan Amount:{{
												loan_details
													.loan_application_details
													.application_currency
											}}
											{{
												utils.numberWithCommas(
													Math.round(
														loan_details
															.loan_application_details
															.application_amount *
															100,
													) / 100,
												)
											}}
										</div>
										<div class="payment">
											Loan Period:
											{{
												loan_details
													.loan_application_details
													.application_loan_term
											}}
										</div>
										<div class="payment">
											Preffered Payment Date:
											{{
												loan_details
													.loan_application_details
													.preffered_repayment_date ||
												'N/A'
											}}
										</div>
										<div class="payment">
											Total Due:
											<span class="tx-blue">{{
												loan_details.loan_outstanding.total_principal_outstanding.toLocaleString(
													'us-US',
												)
											}}</span>
										</div>
										<div class="payment mb-3">
											Due Date:
											<span class="tx-red">{{
												moment(
													loan_details.loan_due
														.due_date,
												).format('Do MMM YYYY')
											}}</span>
										</div>

										<div class="payment">
											Total Outstanding Principle:
											{{
												loan_details.loan_outstanding.total_principal_outstanding.toLocaleString(
													'us-US',
												)
											}}
										</div>
										<div class="payment">
											Total Outstanding Interest:
											{{
												loan_details.loan_outstanding.total_interest_outstanding.toLocaleString(
													'us-US',
												)
											}}
										</div>
										<div class="payment">
											Total Outstanding Penalty:
											{{
												loan_details.loan_outstanding.total_penalty_outstanding.toLocaleString(
													'us-US',
												)
											}}
										</div>
										<div class="payment">
											Total Outstanding charges:
											{{
												loan_details.loan_outstanding.total_charges_outstanding.toLocaleString(
													'us-US',
												)
											}}
										</div>
										<div class="stage">
											Application Stage:
											<b>{{
												loan_details
													.loan_application_details
													.application_status
											}}</b>
										</div>
									</div>
								</div>

								<hr />

								<div class="bottom">
									<Form
										classBinding="row"
										:ref="MyLoanModel.forms.loans_pay.name"
										:forms="
											MyLoanModel.forms.loans_pay.forms
										"
										:formData="
											MyLoanModel.forms.loans_pay.data
										"
									/>

									<!-- @click="requestIPF({ref: $refs[MyLoanModel.forms.ipf.name]})" -->
									<div
										class="btn btn-primary btn-long"
										:disabled="loading"
										@click="
											payLoan({
												ref: $refs[
													MyLoanModel.forms.loans_pay
														.name
												],
											})
										"
									>
										Pay
										<div class="lds-ring" v-show="loading">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</div>
								</div>
							</div>

							<div class="tab-box">
								<div class="tab-switch clearfix">
									<div
										class="tab f-l"
										:class="{ active: activeTabLoan == 1 }"
										@click="openTabLoan(1)"
									>
										Payment
									</div>
									<div
										class="tab f-l"
										:class="{ active: activeTabLoan == 2 }"
										@click="openTabLoan(2)"
									>
										Payment Schedule
									</div>
									<div
										class="tab f-l"
										:class="{ active: activeTabLoan == 3 }"
										@click="openTabLoan(3)"
									>
										Loan Breakdown
									</div>
									<div
										class="tab f-l"
										:class="{ active: activeTabLoan == 4 }"
										@click="openTabLoan(4)"
									>
										Loan Notifications
									</div>
								</div>
								<div class="tab-content">
									<div
										class="content-1"
										v-show="activeTabLoan == 1"
									>
										<div class="transactions">
											<div
												class="empty"
												v-if="
													loan_transactions.length ===
													0
												"
											>
												No Payment Transactions Found!
											</div>
											<div class="content-1" v-else>
												<div class="schedule">
													<div class="row title">
														<div class="col-md-3">
															<div class="txt">
																Tran Ref
															</div>
														</div>
														<div class="col-md-3">
															<div class="txt">
																Date
															</div>
														</div>
														<div class="col-md-4">
															<div class="txt">
																Remarks
															</div>
														</div>
														<div class="col-md-2">
															<div
																class="txt amount"
															>
																Amount
															</div>
														</div>
													</div>
													<div
														class="row"
														v-for="(
															s, i
														) of loan_transactions"
														:key="i"
													>
														<div class="col-md-3">
															<div class="txt">
																{{ s.tran_ref }}
															</div>
														</div>
														<div class="col-md-3">
															<div class="txt">
																{{
																	moment(
																		s.tran_date,
																	).format(
																		'Do MMM YYYY',
																	)
																}}
															</div>
														</div>
														<div class="col-md-4">
															<div class="txt">
																{{ s.remarks }}
															</div>
														</div>
														<div class="col-md-2">
															<div
																class="txt amount"
															>
																<b>{{
																	utils.numberWithCommas(
																		Math.round(
																			s.tran_amount *
																				100,
																		) / 100,
																	)
																}}</b>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div
										class="content-1"
										v-show="activeTabLoan == 2"
									>
										<div class="insurance">
											Payment Schedule
										</div>
										<div class="schedule">
											<div class="row title">
												<div class="col-md-4">
													<div class="txt mb-4">
														Date
													</div>
												</div>
												<div class="col-md-2">
													<div
														class="txt amount mb-4"
													>
														Payment to Principle
													</div>
												</div>
												<div class="col-md-2">
													<div
														class="txt amount mb-4"
													>
														Payment to Interest
													</div>
												</div>
												<div class="col-md-2">
													<div
														class="txt amount mb-4"
													>
														Outstanding Amount
													</div>
												</div>
												<div class="col-md-2">
													<div
														class="txt tx-center mb-4"
													>
														Status
													</div>
												</div>
											</div>
											<div
												class="row"
												v-for="(
													s, i
												) of loan_payment_schedules"
												:key="i"
											>
												<div class="col-md-4">
													<div class="txt">
														<b>{{
															moment(
																s.principal
																	.installment_date,
															).format(
																'Do MMM YYYY',
															)
														}}</b>
													</div>
												</div>
												<div class="col-md-2">
													<div class="txt amount">
														{{
															utils.numberWithCommas(
																Math.round(
																	s.principal
																		.installment_amount *
																		100,
																) / 100,
															)
														}}
													</div>
												</div>
												<div class="col-md-2">
													<div class="txt amount">
														{{
															utils.numberWithCommas(
																Math.round(
																	s.interest
																		.installment_amount *
																		100,
																) / 100,
															)
														}}
													</div>
												</div>
												<div class="col-md-2">
													<div class="txt amount">
														{{
															utils.numberWithCommas(
																Math.round(
																	s.total
																		.outstanding *
																		100,
																) / 100,
															)
														}}
													</div>
												</div>
												<div class="col-md-2">
													<div class="txt tx-center">
														<b>{{ s.status }}</b>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div
										class="content-1"
										v-show="activeTabLoan == 3"
									>
										<div class="insurance">
											Loan Breakdown
										</div>
										<div
											class="card schedule-card"
											v-for="(
												detail, s
											) in loan_payment_schedules"
											:key="s"
										>
											<div class="txt-main">
												<div class="schedule">
													<div class="title">
														Payment Scedule:
														{{ s + 1 }}
													</div>
													<div class="title">
														Payment Date:
														{{
															moment(
																detail.principal
																	.installment_date,
															).format(
																'Do MMM YYYY HH:mm',
															)
														}}
													</div>
													<div class="title mb-3">
														No. of Days:
														{{
															detail.number_of_days
														}}
													</div>
													<!-- <div class="clearfix">
                                          <div class="status f-r" :class="{'tx-yellow': detail.status !== 'PAID'}">{{detail.status}}</div>
                                       </div> -->
													<!-- <div class="row sec total">
                                          <div class="col-md-8">
                                             <div class="small-title">Total Installment Amount</div>
                                          </div>
                                          <div class="col-md-4">
                                             <div class="small-amount">{{detail.total.outstanding.toLocaleString('us-US')}}</div>
                                          </div>
                                          <div class="col-md-8">
                                             <div class="small-title">Total Outstanding</div>
                                          </div>
                                          <div class="col-md-4">
                                             <div class="small-amount">{{detail.total.paid.toLocaleString('us-US')}}</div>
                                          </div>
                                       </div> -->
													<div class="row sec">
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Charges Due
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.charges.outstanding.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Charges Paid
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.charges.paid.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
													</div>

													<div class="row sec">
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Interest Due
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.interest.outstanding.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Interest Paid
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.interest.paid.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
													</div>

													<div class="row sec">
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Penalty Due
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.penalty.outstanding.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Penalty Paid
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.penalty.paid.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
													</div>

													<div class="row sec">
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Pricipal Due
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.principal.outstanding.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
														<div class="col-md-8">
															<div
																class="small-title"
															>
																Pricipal Paid
															</div>
														</div>
														<div class="col-md-4">
															<div
																class="small-amount"
															>
																{{
																	detail.principal.paid.toLocaleString(
																		'us-US',
																	)
																}}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div
										class="content-1"
										v-show="activeTabLoan == 4"
									>
										<div class="card">
											<div
												class="notification"
												v-for="(
													notification, i
												) in loan_notifications"
												:key="i"
											>
												<div class="content-box">
													<div class="top clearfix">
														<div class="title f-l">
															{{
																notification.subject
															}}
														</div>
														<div class="date f-r">
															{{
																moment(
																	notification.created_at,
																).fromNow()
															}}
														</div>
													</div>
													<div
														class="bottom clearfix"
													>
														<div
															class="txt"
															v-html="
																notification.notification
															"
														></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<AddReview />
		<ShowReviews title="Loan Product Reviews" />
	</div>
</template>

<script>
export default {
	components: {
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
		AddReview: () => import('../templates/others/review'),
		ShowReviews: () => import('../templates/others/list-reviews'),
	},
	computed: {
		...mapGetters([
			'loading',
			'school_loan_details_table',
			'loan_details',
			'showViewLoan',
			'loan_transactions',
			'loan_notifications',
			'loan_account_details',
			'MyLoanModel',
			'activeTabLoan',
			'loan_payment_schedules',
		]),
	},
	data() {
		return {
			utils,
			moment,
			api,
			activeTab: 1,
		};
	},
	methods: {
		...mapActions([
			'requestIPF',
			'payLoan',
			'openTabLoan',
			'fetchMyLoanReviews',
			'fetchTopupOptionsUpdate',
			'fetchProductReviews',
		]),
		async clickAction(action) {
			switch (action) {
				case 'list_reviews':
					await this.fetchMyLoanReviews();
					this.$store.commit('showListReview', true);
					Event.$emit('loader:show', false);
					break;
				case 'add_review':
					this.$store.commit('showAddReviews', true);
					break;
				default:
					break;
			}
		},
		getOutstandingAmount(s) {
			let due =
				s.paymentToPrinciple +
				s.paymentToInterest +
				s.feesDue +
				s.penaltiesDue;
			let payment =
				s.principalPayment +
				s.interestPayment +
				s.feePayment +
				s.penaltyPayment;

			return utils.numberWithCommas(
				Math.round(Math.abs(due - payment) * 100) / 100,
			);
		},
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-loan {
	.row.sec {
		padding: 10px 0 !important;
	}
	.schedule {
		.amount {
			text-align: right;
		}
		.status {
			text-transform: uppercase;
			font-weight: 600;
			font-size: 13px;
		}
	}
	.small-margin {
		padding: 0px 10px !important;
	}
	.small-title {
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
	}
	.small-amount {
		text-align: right;
		font-size: 13px;
		font-weight: 600;
	}

	.status {
		font-size: 12px;
		text-transform: uppercase;
		font-weight: 600;

		&.tx-yellow {
			color: var(--ne-yellow);
		}
	}
	.detail-box {
		margin: 30px 0 0 0;

		.payment {
			margin: 2px 0;
			font-size: 13px;

			.overdue {
				color: var(--ne-blue);
			}
		}
		.stage {
			font-size: 13px;

			b {
				color: #9c7bfc;
			}
		}
	}
	.notification {
		padding: 22px 0;
		border-bottom: solid 1px #f5f9fb;
		cursor: pointer;

		.content-box {
			width: calc(100% - 65px);

			.title {
				color: #3d4661;
				font-weight: 600;
				font-size: 16px;
			}
			.txt {
				color: #646f79;
				font-size: 14px;
			}
			.date {
				color: #646f79;
				font-size: 13px;
				font-weight: 600;
			}
		}
	}
	.card.details-card {
		padding: 10px;

		.title {
			font-size: 13px;
			font-weight: 600;
			text-transform: uppercase;
			margin: 0 0 10px 0;

			&.total {
				padding: -7px 0 7px 0;
				margin: -10px 0 5px -10px;
				border-bottom: solid 1px var(--border-grey);
			}
		}
		.th {
			font-size: 12px;
		}
		.tr {
			font-size: 13px;
			font-weight: 600;
			text-align: right;
		}
	}
	.insurance {
		font-weight: 600;
		font-size: 16px;
		margin: 0 0 30px 0;
	}
	.icon-box {
		.txt-box {
			margin: 20px 0 0 0;
		}
		.logo {
			width: 80px;
			height: auto;
			min-height: 20px;
			margin: 10px 10px 0 0;
		}
		.bank {
			font-size: 13px;
			font-weight: 600;
			color: var(--primary);
		}

		.product {
			color: @grey;
			font-weight: 600;
		}
	}
	.ref {
		font-size: 13px;
	}
	.empty {
		text-align: center;
		padding: 40px 0;
		font-size: 13px;
		color: var(--ne-red);
	}
	.payment {
		font-size: 14px;
		font-weight: 600;

		b {
			color: var(--primary) !important;
		}
	}
	.status {
		color: var(--ne-green);
		font-size: 14px;
		font-weight: 600;
	}

	.transactions {
		margin: 30px -30px 20px -30px;
	}
}
</style>
